import {
Component,
Input,
Output,
EventEmitter,
TemplateRef,
} from '@angular/core';
import {
WeekViewAllDayEvent,
WeekViewTimeEvent,
WeekViewHourColumn,
} from 'calendar-utils';
import { PlacementArray } from 'positioning';
import {User} from "../models";
import {Service} from "../models/service";
import {ExitWithoutSaveDialogComponent} from "./dialog/exitWithoutSaveDialog.component";
import {FormGroup} from "@angular/forms";
import {MatDialog} from "@angular/material/dialog";
import {ConfirmExerciseDialogComponent} from "./dialog/confirmExerciseDialog.component";

    @Component({
    selector: 'custom-calendar-week-view-event',
        template: `
          <ng-template
            #defaultTemplate
            let-weekEvent="weekEvent"
            let-tooltipPlacement="tooltipPlacement"
            let-eventClicked="eventClicked"
            let-tooltipTemplate="tooltipTemplate"
            let-tooltipAppendToBody="tooltipAppendToBody"
            let-tooltipDisabled="tooltipDisabled"
            let-tooltipDelay="tooltipDelay"
            let-column="column"
            let-daysInWeek="daysInWeek"
          >
            <div
              class="cal-event"
              [ngStyle]="{
                backgroundColor: weekEvent.event.color?.secondary,
                borderColor: weekEvent.event.color?.primary
              }"
              [mwlCalendarTooltip]="
                !tooltipDisabled
                  ? (weekEvent.event.title
                    | calendarEventTitle
                      : (daysInWeek === 1 ? 'dayTooltip' : 'weekTooltip')
                      : weekEvent.tempEvent || weekEvent.event)
                  : ''
              "
              [tooltipPlacement]="tooltipPlacement"
              [tooltipEvent]="weekEvent.tempEvent || weekEvent.event"
              [tooltipTemplate]="tooltipTemplate"
              [tooltipAppendToBody]="tooltipAppendToBody"
              [tooltipDelay]="tooltipDelay"
              (mwlClick)="eventClicked.emit({ sourceEvent: $event })"
              (mwlKeydownEnter)="eventClicked.emit({ sourceEvent: $event })"
              tabindex="0"
              role="application"
              [attr.aria-label]="
                { event: weekEvent.tempEvent || weekEvent.event, locale: locale }
                  | calendarA11y: 'eventDescription'
              "
            >
              <mwl-calendar-event-actions
                [event]="weekEvent.tempEvent || weekEvent.event"
                [customTemplate]="eventActionsTemplate"
              >
              </mwl-calendar-event-actions>
              &ngsp;
              <mwl-calendar-event-title
                [event]="weekEvent.tempEvent || weekEvent.event"
                [customTemplate]="eventTitleTemplate"
                [view]="daysInWeek === 1 ? 'day' : 'week'"
              >
              </mwl-calendar-event-title>
                <div style="background-color: white;" *ngIf="service || customer">
                    <span *ngIf="service">{{service.name}}<br/></span>
                    <span *ngIf="customer">{{customer.firstName}} {{customer.lastName}}</span>
                    <span *ngIf="!weekEvent.event.meta.completed && weekEvent.event.meta.service && !weekEvent.event.meta.groupActivity">
                        <br/>
                        <button (click)="handleConfirmClick($event, weekEvent.event.meta.customer, weekEvent.event.meta.service)" mat-button="filled" class="mr-8" color="primary"><b style="color: green;">Zrealizuj</b></button>
                    </span>
                </div>
            </div>
          </ng-template>
          <ng-template
            [ngTemplateOutlet]="customTemplate || defaultTemplate"
            [ngTemplateOutletContext]="{
              weekEvent: weekEvent,
              tooltipPlacement: tooltipPlacement,
              eventClicked: eventClicked,
              tooltipTemplate: tooltipTemplate,
              tooltipAppendToBody: tooltipAppendToBody,
              tooltipDisabled: tooltipDisabled,
              tooltipDelay: tooltipDelay,
              column: column,
              daysInWeek: daysInWeek
            }"
          >
          </ng-template>
        `,
        })
export class CustomCalendarWeekViewEventComponent {
        confirmDialogRef: any;
@Input() locale: string;

@Input() weekEvent: WeekViewAllDayEvent | WeekViewTimeEvent;

@Input() tooltipPlacement: PlacementArray;

@Input() tooltipAppendToBody: boolean;

@Input() tooltipDisabled: boolean;

@Input() tooltipDelay: number | null;

@Input() customTemplate: TemplateRef<any>;

@Input() eventTitleTemplate: TemplateRef<any>;

@Input() eventActionsTemplate: TemplateRef<any>;

@Input() tooltipTemplate: TemplateRef<any>;

@Input() column: WeekViewHourColumn;

@Input() daysInWeek: number;

@Input() service: Service;
@Input() customer: User;

@Output() eventClicked = new EventEmitter<{
sourceEvent: MouseEvent | any;
}>();

    constructor(
        public _matDialog: MatDialog
    ) {

    }

    handleConfirmClick(event: MouseEvent, user: User, service: Service): void {
        event.stopPropagation();
        event.preventDefault();
        this.confirmExercise(user, service);
    }

    confirmExercise(user: User, service: Service): void {
            this.confirmDialogRef = this._matDialog.open(ConfirmExerciseDialogComponent, {
                panelClass: 'confirm-exercise-dialog',
                data      : {
                    user: user,
                    service: service,
                    reservationDataId: this.weekEvent.event.id
                },
                width: '400px',
            });

            this.confirmDialogRef.afterClosed()
                .subscribe((response: FormGroup) => {
                    if (!response) {
                        return;
                    }

                    window.location.reload();

                    this.confirmDialogRef.close();
                }, (err) => {
                    console.log(err);
                });
    }
}